<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Kutsu spetsialist</h3>
        </template>

        <template #right>
          <a @click="$router.go(-1)" class="btn-circle cursor-pointer">
            <i class="text-xl text-blue-500 pi pi-times"></i>
          </a>
        </template>

        <div class="max-w-xl mx-auto flex flex-col justify-between">
            <div class="mb-8 mt-32 md:mt-40">
                <div class="w-full p-float-label p-input-icon-right mb-10">
                    <i class="pi pi-search" />
                    <auto-complete
                        id="name"
                        placeholder=" "
                        v-model="name"
                        field="name"
                        :suggestions="filteredNames"
                        class="w-full"
                        @complete="searchNames($event)"
                        :forceSelection="true"
                    >
                    </auto-complete>
                    <label for="name" class="text-blue-500 uppercase">Nimi</label>
                </div>

                <div class="mb-10">
                    <h4 class="text-sm text-blue-500 uppercase">Valdkond</h4>

                    <dropdown
                        v-model="areaSelected"
                        :options="areas"
                        :disabled="hasAreaQueryParam"
                        option-label="name"
                        option-value="id"
                        class="w-full text-gray-900"
                    />
                </div>

                <div v-if="hasLeadQueryParam" class="mb-10">
                  <h4 class="text-sm text-blue-500 uppercase">Projekteerija</h4>

                  <dropdown
                      v-model="isLeadSelected"
                      :options="draftsmanOptions"
                      :disabled="hasLeadQueryParam"
                      option-label="name"
                      option-value="isLead"
                      class="w-full text-gray-900"
                  />
                </div>
            </div>

            <div class="flex justify-center mt-12">
                <button
                    @click="addSpecialist"
                    :class="{ 'opacity-50 pointer-events-none': !name || !areaSelected }"
                    class="w-full sm:w-72 text-white bg-orange-400 btn"
                >Saada kutse
                </button>
            </div>

            <div class="pt-6">
              Kas ei leidnud soovitud spetsialisti? Kutsu ta meie keskkonda <router-link :to="'/user/new/' + $route.params.projectUserId" class="text-blue-500">registreeruma</router-link>.
            </div>
        </div>
    </framed-layout>
</template>

<script>
// import axios from 'axios'
import FramedLayout from './../Layouts/FramedLayout'
import {addSpecialist, getAddSpecialist, searchSpecialist} from "@/store/team.api";

export default {
    components: {
        FramedLayout
    },
    data() {
        return {
            area: null,
            areas: [],
            name: null,
            filteredNames: null,
            areaSelected: null,
            hasLeadQueryParam: null,
            hasAreaQueryParam: null,
            isLeadSelected: null,
            draftsmanOptions: [{
              name: "Vastutav",
              isLead: true
            }, {
              name: "Tehnik",
              isLead: false
            }],
        }
    },
    async mounted() {
      var isLeadQueryParam;

      if (this.$route.query?.isLead !== undefined) {
        isLeadQueryParam = (String(this.$route.query?.isLead).toLowerCase() === 'true');
        this.hasLeadQueryParam = true;
      } else {
        this.hasLeadQueryParam = false
      }

      this.draftsmanOptions.some((obj) => {
        if(obj.isLead === isLeadQueryParam) {
          this.isLeadSelected = obj.isLead;
        }
      });


      if (this.$route.query?.areaId !== undefined) {
        this.areaSelected = this.$route.query?.areaId;
        this.hasAreaQueryParam = true;
      } else {
        this.hasAreaQueryParam = false;
      }

      const { data } = await getAddSpecialist(this.$route.params.projectUserId, this.areaSelected);

      this.areas = data?.areas;

      this.area = data?.area;
      this.areaSelected = data?.area;
    },
    methods: {
        searchNames(event) {
            if (!this.areaSelected) {
              this.$toast.add({
                severity: 'warn',
                summary: "Palun vali valdkond",
                life: 3000,
                closable: false
              })

              return;
            }

            if (this.isLeadSelected === null && this.hasLeadQueryParam) {
              this.$toast.add({
                severity: 'warn',
                summary: "Palun vali projekteerija",
                life: 3000,
                closable: false
              })

              return;
            }

          const config = {
            params: {
              s: event.query,
              projectUserId: this.$route.params.projectUserId,
              areaId: this.areaSelected,
              isLead: this.isLeadSelected
            }
          };
          searchSpecialist(config).then(response => {
              this.filteredNames = response.data
          })
        },
        addSpecialist() {
            if (!(this.name instanceof Object)) {
              let message = "Palun vali spetsialist rippmenüüst, mis tekib nime trükkimisel. " +
                            "Kui soovitud spetsialisti ei leitud, võid isiku kutsuda " +
                            "liituma meie Iffent platvormiga";
              this.showToast(message, "warn", 6000);
              this.name = null;
              return;
            }

            const payload = {
                projectUserId: this.$route.params.projectUserId,
                specialist: this.name,
                areaId: this.areaSelected,
                isLead: this.isLeadSelected
            };
            addSpecialist(payload).then(({ data }) => {
                this.processAxiosPositiveResponse(data);
                this.name = null;
            })
        },
    }
}
</script>
